import {createSlice, createAsyncThunk} from '@reduxjs/toolkit';
import type {RootState} from './store';
import {employeesigninApiCall} from '../api/employeesignin-api';
import {
  employeePasswordResponse,
  employeeTempPasswordRequest,
} from '../lib/types';
import {employeeforgetpasswordapicall} from '../api/employeepassword.api';
//import axios from 'axios';

const employeeSignInData = {
  statusCode: '',
  statusMessage: '',
};

interface employeeSigninState {
  employeeForgetPasswordApiData: employeePasswordResponse;
  loading: boolean;
  error: string;
}

// Define the initial state using that type
const initialState: employeeSigninState = {
  employeeForgetPasswordApiData: employeeSignInData,
  loading: false,
  error: '',
};

export const employeeforgetpasswordcall = createAsyncThunk(
  'employee/employeeresetpassword',
  async (parameters: employeeTempPasswordRequest, thunkApi) => {
    return employeeforgetpasswordapicall(parameters)
      .then(response => {
        return response;
      })
      .catch(error => {
        return thunkApi.rejectWithValue(error.response.data);
      });
  },
);
export const employeeForgetPasswordSlice = createSlice({
  name: 'employeeforgetpassowrd',
  // `createSlice` will infer the state type from the `initialState` argument
  initialState,
  reducers: {
    resetState: () => initialState,
  },
  extraReducers: builder => {
    builder.addCase(employeeforgetpasswordcall.pending, state => {
      state.loading = true;
    });
    builder.addCase(employeeforgetpasswordcall.fulfilled, (state, action) => {
      state.loading = false;
      state.employeeForgetPasswordApiData = action.payload;
    });
    builder.addCase(employeeforgetpasswordcall.rejected, (state, action) => {
      state.error = action.toString();

      state.loading = false;
    });
  },
});

//Other code such as selectors can use the imported `RootState` type
export const {resetState} = employeeForgetPasswordSlice.actions;

export const employeeForgetPasswordData = (
  state: RootState,
): employeePasswordResponse =>
  state.employeeForgetPasswordReducer.employeeForgetPasswordApiData;
export const error = (state: RootState): string =>
  state.employeeForgetPasswordReducer.error;
export const loading = (state: RootState): boolean =>
  state.employeeForgetPasswordReducer.loading;

export default employeeForgetPasswordSlice.reducer;
